export { default } from 'cccisd-game-quizshow';
